/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CertificateDto,
  IssuedCertificatesDto,
  ProblemDetails,
  ReissuedCertificatesDto
} from '.././model';

import { request } from '../../http-client';




export const postApiV1MissionsMissionIdCertificates = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<IssuedCertificatesDto>(
      {url: `/api/v1/missions/${missionId}/certificates`, method: 'POST', signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdCertificatesMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdCertificates>>, TError,{missionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdCertificates>>, TError,{missionId: string}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdCertificates'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdCertificates>>, {missionId: string}> = (props) => {
          const {missionId} = props ?? {};

          return  postApiV1MissionsMissionIdCertificates(missionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdCertificatesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdCertificates>>>
    
    export type PostApiV1MissionsMissionIdCertificatesMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdCertificates = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdCertificates>>, TError,{missionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdCertificates>>,
        TError,
        {missionId: string},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdCertificatesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdCertificatesReissue = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<ReissuedCertificatesDto>(
      {url: `/api/v1/missions/${missionId}/certificates/reissue`, method: 'POST', signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdCertificatesReissueMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdCertificatesReissue>>, TError,{missionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdCertificatesReissue>>, TError,{missionId: string}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdCertificatesReissue'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdCertificatesReissue>>, {missionId: string}> = (props) => {
          const {missionId} = props ?? {};

          return  postApiV1MissionsMissionIdCertificatesReissue(missionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdCertificatesReissueMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdCertificatesReissue>>>
    
    export type PostApiV1MissionsMissionIdCertificatesReissueMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdCertificatesReissue = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdCertificatesReissue>>, TError,{missionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdCertificatesReissue>>,
        TError,
        {missionId: string},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdCertificatesReissueMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiV1CertificatesMine = (
    
 signal?: AbortSignal
) => {
      
      
      return request<CertificateDto[]>(
      {url: `/api/v1/certificates/mine`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1CertificatesMineQueryKey = () => {
    return [
    `/api/v1/certificates/mine`
    ] as const;
    }

    
export const getGetApiV1CertificatesMineQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1CertificatesMine>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CertificatesMine>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1CertificatesMineQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1CertificatesMine>>> = ({ signal }) => getApiV1CertificatesMine(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1CertificatesMine>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1CertificatesMineQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1CertificatesMine>>>
export type GetApiV1CertificatesMineQueryError = unknown


export function useGetApiV1CertificatesMine<TData = Awaited<ReturnType<typeof getApiV1CertificatesMine>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CertificatesMine>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1CertificatesMine>>,
          TError,
          Awaited<ReturnType<typeof getApiV1CertificatesMine>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1CertificatesMine<TData = Awaited<ReturnType<typeof getApiV1CertificatesMine>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CertificatesMine>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1CertificatesMine>>,
          TError,
          Awaited<ReturnType<typeof getApiV1CertificatesMine>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1CertificatesMine<TData = Awaited<ReturnType<typeof getApiV1CertificatesMine>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CertificatesMine>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1CertificatesMine<TData = Awaited<ReturnType<typeof getApiV1CertificatesMine>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CertificatesMine>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1CertificatesMineQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1CertificatesIdFile = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return request<string>(
      {url: `/api/v1/certificates/${id}/file`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1CertificatesIdFileQueryKey = (id?: string,) => {
    return [
    `/api/v1/certificates/${id}/file`
    ] as const;
    }

    
export const getGetApiV1CertificatesIdFileQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1CertificatesIdFileQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>> = ({ signal }) => getApiV1CertificatesIdFile(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1CertificatesIdFileQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>>
export type GetApiV1CertificatesIdFileQueryError = ProblemDetails


export function useGetApiV1CertificatesIdFile<TData = Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>,
          TError,
          Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1CertificatesIdFile<TData = Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>,
          TError,
          Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1CertificatesIdFile<TData = Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1CertificatesIdFile<TData = Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CertificatesIdFile>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1CertificatesIdFileQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




